import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line no-restricted-imports
import { Button, Form, Modal } from 'semantic-ui-react';

import { functions } from '../../../api/firebase/firebase';

import { formatFullName } from '../../../helpers/utils';

import UserRolesDropdown from './UserRolesDropdown';
import UserSettingsFlags from './UserSettingsFlags';

function UsersDetail({ user, onClose }) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const [userRoles, setUserRoles] = useState([]);

  if (!user) return null;

  const { id, uid, email } = user;

  return (
    <Modal closeIcon onClose={onClose} open={true} closeOnDimmerClick={false} closeOnEscape={false}>
      <Modal.Header>{user.displayName ?? formatFullName(user, true)}</Modal.Header>
      <Modal.Content>
        <Modal.Description></Modal.Description>
        <Modal.Description>{renderForm()}</Modal.Description>
      </Modal.Content>
    </Modal>
  );

  function renderForm() {
    return (
      <Form onSubmit={onSubmit}>
        <Form.Group widths="equal">
          <Form.Field>
            <label>{t('admin.users.userId')}</label>
            <div>{uid || id}</div>
          </Form.Field>

          <Form.Field>
            <label>{t('common.email')}</label>
            <div>{email}</div>
          </Form.Field>
        </Form.Group>

        <UserRolesDropdown
          user={user}
          userRoles={userRoles}
          onUserRolesChange={(_userRoles) => setUserRoles(_userRoles)}
        />

        {user?.defaultOrganization && <UserSettingsFlags organizationId={user.defaultOrganization} userId={user.id} />}

        <Button primary type="submit" loading={loading} content={t('admin.users.submitAction')} />
        <Button basic loading={loading} content={t('common.cancel')} onClick={onCancel} />
      </Form>
    );
  }

  function onCancel() {
    onClose();
  }

  async function onSubmit(e) {
    e.preventDefault();

    try {
      setLoading(true);

      if (userRoles?.length > 0) {
        await functions().httpsCallable('callables-users-grantRoles')({
          uid: uid || id,
          email,
          roles: userRoles,
        });
      }
      onCancel();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }
}
export default UsersDetail;
